<div class="inner-header d-flex pb-3">
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li
                class="breadcrumb-item"
                *ngFor="let breadcrumbItem of menuItems; let last = last"
            >
                <a
                    [routerLink]="breadcrumbItem.url"
                    *ngIf="!last"
                    class="font-weight-medium"
                    >{{ breadcrumbItem.label }}</a
                >
                <span *ngIf="last">{{ breadcrumbItem.label }}</span>
            </li>
        </ol>
    </nav>
</div>
